import { TableCell, TableRow } from "@pushpress/pushpress-ui";

type EmptySubAccountsTableProps = {
  colLength?: number;
  userUuid?: string;
  title?: string;
  subtitle?: string;
  action?: React.ReactNode;
};

export default function EmptyTable({
  title,
  subtitle,
  action,
  colLength,
}: EmptySubAccountsTableProps) {
  return (
    <TableRow>
      <TableCell colSpan={colLength} className="tw-h-24 tw-text-center">
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-8 tw-text-center">
          <h4 className="tw-mb-2">{title}</h4>
          <p className="tw-text-neutral-500 tw-mb-6">{subtitle}</p>
          <div className="tw-flex tw-gap-4">{action}</div>
        </div>
      </TableCell>
    </TableRow>
  );
}
